// OTPProtected.js
import React, { useState } from "react";

export default function OTPProtected({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [enteredOtp, setEnteredOtp] = useState("");

  const correctOtp = "2001"; // fixed OTP you want

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    if (enteredOtp.trim() === correctOtp) {
      setIsAuthenticated(true);
    } else {
      alert("Incorrect OTP. Please try again.");
      setEnteredOtp("");
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100">
        <div className="bg-white p-8 rounded shadow-lg max-w-sm w-full">
          <h2 className="text-xl font-bold mb-4 text-center">
            Enter OTP to Access
          </h2>
          <form onSubmit={handleOtpSubmit}>
            <input
              type="password"
              placeholder="Enter OTP"
              value={enteredOtp}
              onChange={(e) => setEnteredOtp(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded mb-4"
            />
            <button
              type="submit"
              className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
            >
              Submit OTP
            </button>
          </form>
        </div>
      </div>
    );
  }

  // If OTP is correct → show whatever is inside
  return <>{children}</>;
}
